module.exports = __webpack_public_path__ + "static/media/lightbox.1b68e258.png";